module.exports = __webpack_public_path__ + "static/media/bluePattern.7bb7e4f4.svg";